import React from 'react';

import {
  AirportShuttleOutlined,
  ArticleOutlined,
  AssignmentLate,
  BadgeOutlined,
  BugReport,
  CheckBoxOutlined,
  ChildCare,
  DirectionsCarOutlined,
  FactCheckOutlined,
  FormatListBulletedOutlined,
  GavelOutlined,
  GroupAddOutlined,
  History,
  Home,
  Info,
  ListAltOutlined,
  NoAccountsOutlined,
  NoteAddOutlined,
  NoteAltTwoTone,
  PersonAddAlt1Outlined,
  PersonSearchOutlined,
  Pets,
  PlagiarismOutlined,
  RequestQuoteOutlined,
  SsidChartOutlined,
  SummarizeOutlined,
  VerifiedUserOutlined,
} from '@mui/icons-material';

import { SvgIcon } from '@mui/material';

import { ReactComponent as ApproveDelegation } from 'assets/icons/approveDelagation.svg';
import { ReactComponent as AttachMoney } from 'assets/icons/attach-money.svg';
import { ReactComponent as InvoiceLetter } from 'assets/icons/invoice.svg';
import { ReactComponent as Movie } from 'assets/icons/movie.svg';
import { ReactComponent as Orders } from 'assets/icons/orders.svg';
import { ReactComponent as SettingsCinematic } from 'assets/icons/settingsCinematic.svg';
import { ReactComponent as Today } from 'assets/icons/today.svg';

import { typesReports } from 'commons/constants';
import { APP_VERSION } from 'commons/constants/app';
import { TYPE_PROFILES } from 'commons/constants/orderProfiles';
import * as PERMISSIONS from 'commons/constants/permissions';
import * as PROFILES from 'commons/constants/profiles';
import { UserPermission, UserProfile } from 'commons/types/user';

export type MenuItem = {
  id: string;
  label: string;
  icon: React.ElementType;
  path: string;
  permissions: UserPermission[];
  profiles?: UserProfile[];
  subItems?: MenuItem[];
  onClick?: () => void;
};

const MenuItems: MenuItem[] = [
  {
    id: 'home',
    label: 'Home',
    icon: Home,
    path: '/',
    permissions: [],
    profiles: [PROFILES.TIME_COMFIGURA, PROFILES.GESTAO_FIGURACAO],
  },
  {
    id: 'sentry',
    label: 'Teste Sentry',
    icon: BugReport,
    path: '/',
    permissions: [],
    onClick: () => {
      throw new Error('Teste Sentry');
    },
    profiles: [PROFILES.TIME_COMFIGURA],
  },
  {
    id: 'document_Signing',
    label: 'POC - Assinatura de documento',
    icon: NoteAltTwoTone,
    path: '/document-Signing',
    permissions: [],
    profiles: [PROFILES.TIME_COMFIGURA],
  },
  {
    id: 'app_version',
    label: `Release Version: ${APP_VERSION}`,
    icon: Info,
    path: '/',
    permissions: [],
    onClick: () => {},
    profiles: [PROFILES.TIME_COMFIGURA],
  },
  {
    id: 'request_figurant',
    label: 'Solicitação de figuração',
    icon: () => <SvgIcon component={Movie} inheritViewBox />,
    path: '/solicitacao-figurante',
    permissions: [PERMISSIONS.SOLICITACAO_PEDIDO_FIGURACAO],
    profiles: [PROFILES.GESTAO_FIGURACAO, PROFILES.ASSISTENTE_DIRECAO],
  },
  {
    id: 'search_figurant',
    label: 'Buscar figurante',
    icon: PersonSearchOutlined,
    path: '/busca-por-figurante',
    permissions: [PERMISSIONS.BUSCA_GERAL],
    profiles: [
      PROFILES.PRODUTOR_AGENCIA,
      PROFILES.ASSISTENTE_DIRECAO,
      PROFILES.GESTAO_FIGURACAO,
      PROFILES.SOCIO_AGENCIA,
    ],
  },
  {
    id: 'check_requests',
    label: 'Conferir Pedidos',
    icon: Orders,
    path: '/conferir-pedidos',
    permissions: [PERMISSIONS.CADASTRO_CARTA_FATURA],
    profiles: [PROFILES.GESTAO_FIGURACAO],
  },
  {
    id: 'request_figurant_previous',
    label: 'Pedidos de fig. anteriores',
    icon: History,
    path: '/pedidos-filtrado',
    permissions: [PERMISSIONS.BUSCA_PEDIDO_FIGURACAO],
    profiles: [PROFILES.GESTAO_FIGURACAO, PROFILES.PRODUTOR_AGENCIA, PROFILES.SOCIO_AGENCIA],
  },
  {
    id: 'figurant_requests_agency',
    label: 'Pedidos de fig. (agência)',
    icon: ListAltOutlined,
    path: `/pedidos?profile=${TYPE_PROFILES.PRODUCER_AGENCY}`,
    permissions: [PERMISSIONS.BUSCA_PEDIDO_FIGURACAO],
    profiles: [PROFILES.GESTAO_FIGURACAO, PROFILES.PRODUTOR_AGENCIA, PROFILES.SOCIO_AGENCIA],
  },
  {
    id: 'figurant_requests_director_assistant',
    label: 'Pedidos de fig. (ass. de direção)',
    icon: FactCheckOutlined,
    path: `/pedidos?profile=${TYPE_PROFILES.ASSISTANT_DIRECTOR}`,
    permissions: [PERMISSIONS.BUSCA_PEDIDO_FIGURACAO],
    profiles: [PROFILES.GESTAO_FIGURACAO, PROFILES.ASSISTENTE_DIRECAO],
  },
  {
    id: 'figuration_deliberation',
    label: 'Deliberação de Figuração',
    icon: GavelOutlined,
    path: `/pedidos?profile=${TYPE_PROFILES.GLOBO_PRODUCER}`,
    permissions: [PERMISSIONS.BUSCA_PEDIDO_FIGURACAO],
    profiles: [PROFILES.GESTAO_FIGURACAO, PROFILES.PRODUTOR_GLOBO],
  },
  {
    id: 'figuration_requests_production',
    label: 'Pedidos de transporte noturno',
    icon: ListAltOutlined,
    path: `/pedidos?profile=${TYPE_PROFILES.PRODUCTION_BASE}`,
    permissions: [PERMISSIONS.BUSCA_PEDIDO_FIGURACAO],
    profiles: [PROFILES.GESTAO_FIGURACAO, PROFILES.BASE_PRODUCAO],
  },
  {
    id: 'generate_invoice_letter',
    label: 'Gerar carta fatura',
    icon: InvoiceLetter,
    path: '/gerar-carta-fatura',
    permissions: [PERMISSIONS.CADASTRO_CARTA_FATURA],
    profiles: [PROFILES.GESTAO_FIGURACAO],
  },
  {
    id: 'search_invoice_letter',
    label: 'Buscar carta fatura',
    icon: () => <SvgIcon component={AttachMoney} inheritViewBox />,
    path: '/buscar-carta-fatura',
    permissions: [PERMISSIONS.BUSCA_CARTA_FATURA],
    profiles: [PROFILES.GESTAO_FIGURACAO, PROFILES.SOCIO_AGENCIA],
  },
  {
    id: 'register',
    label: 'Cadastrar',
    icon: PersonAddAlt1Outlined,
    path: '',
    permissions: [
      PERMISSIONS.CADASTRO_FIGURANTE,
      PERMISSIONS.CADASTRO_FIGURANTE_ANIMAL,
      PERMISSIONS.CADASTRO_FIGURANTE_VEICULO,
      PERMISSIONS.CADASTRO_FIGURANTE_FISCAL,
    ],
    profiles: [PROFILES.GESTAO_FIGURACAO, PROFILES.PRODUTOR_AGENCIA, PROFILES.SOCIO_AGENCIA],
    subItems: [
      {
        id: 'register_figurant',
        label: 'Cadastrar figurante',
        icon: GroupAddOutlined,
        path: '/figurante',
        permissions: [PERMISSIONS.CADASTRO_FIGURANTE],
      },
      {
        id: 'register_animal',
        label: 'Cadastrar animal',
        icon: Pets,
        path: '/animal-figurante',
        permissions: [PERMISSIONS.CADASTRO_FIGURANTE_ANIMAL],
      },
      {
        id: 'register_vehicle',
        label: 'Cadastrar veículo',
        icon: DirectionsCarOutlined,
        path: '/veiculo-figurante',
        permissions: [PERMISSIONS.CADASTRO_FIGURANTE_VEICULO],
      },
      {
        id: 'register_fiscal',
        label: 'Cadastrar fiscal',
        icon: PersonAddAlt1Outlined,
        path: '/fiscal-de-figurante',
        permissions: [PERMISSIONS.CADASTRO_FIGURANTE_FISCAL],
      },
    ],
  },
  {
    id: 'register_permit',
    label: 'Cadastrar alvará',
    icon: NoteAddOutlined,
    path: '/alvara',
    permissions: [PERMISSIONS.CADASTRO_FIGURANTE_ALVARA],
    profiles: [PROFILES.GESTAO_FIGURACAO],
  },
  {
    id: 'search_permit',
    label: 'Buscar alvará',
    icon: PlagiarismOutlined,
    path: '/busca-por-alvara',
    permissions: [PERMISSIONS.CADASTRO_FIGURANTE_ALVARA],
    profiles: [PROFILES.GESTAO_FIGURACAO],
  },
  {
    id: 'content_management',
    label: 'Gerenciamento de conteúdos',
    icon: () => <SvgIcon component={SettingsCinematic} inheritViewBox />,
    path: '/gerenciamento-de-conteudos',
    permissions: [PERMISSIONS.GESTAO_CONTEUDO],
    profiles: [PROFILES.GESTAO_FIGURACAO],
  },
  {
    id: 'check_in_figurant',
    label: 'Checkin de figurantes',
    icon: BadgeOutlined,
    path: '/figurante-presenca',
    permissions: [PERMISSIONS.CHECKIN_FIGURANTE],
    profiles: [PROFILES.GESTAO_FIGURACAO, PROFILES.PORTARIA_SEGURANCA],
  },
  {
    id: 'figurant_of_the_day',
    label: 'Figuração do dia',
    icon: () => <SvgIcon component={Today} inheritViewBox />,
    path: '/figuracoes-do-dia',
    permissions: [PERMISSIONS.CHECKIN_FIGURANTE],
    profiles: [PROFILES.GESTAO_FIGURACAO, PROFILES.PORTARIA_SEGURANCA],
  },
  {
    id: 'executive_producer_approval',
    label: 'Aprovação produtor executivo',
    icon: () => <SvgIcon component={ApproveDelegation} inheritViewBox />,
    path: '/aprovacao-produtor-executivo',
    permissions: [PERMISSIONS.APROVACAO_PRODUTOR_EXECUTIVO],
    profiles: [PROFILES.GESTAO_FIGURACAO, PROFILES.PRODUTOR_EXECUTIVO],
  },
  {
    id: 'recording_reports',
    label: 'Relatório de gravação',
    icon: AssignmentLate,
    path: '/recording-reports',
    permissions: [], // TODO: Adicionar permissoes
    profiles: [PROFILES.GESTAO_FIGURACAO],
  },
  {
    id: 'transport_security',
    label: 'Segurança de transporte',
    icon: () => <AirportShuttleOutlined />,
    path: '/seguranca-de-transporte',
    permissions: [PERMISSIONS.SEGURANCA_TRANSPORTE],
    profiles: [PROFILES.GESTAO_FIGURACAO, PROFILES.SEGURANCA_EMPRESARIAL],
  },
  {
    id: 'reports',
    label: 'Relatórios',
    icon: ArticleOutlined,
    path: '',
    permissions: [
      PERMISSIONS.RELATORIO_GERENCIAL,
      PERMISSIONS.RELATORIO_GERENCIAL_AGENCIA,
      PERMISSIONS.RELATORIO_ITEM_PEDIDO,
      PERMISSIONS.RELATORIO_VALORACAO,
      PERMISSIONS.RELATORIO_ALVARA_MENOR,
      PERMISSIONS.RELATORIO_PORTARIA_SEGURANCA,
      PERMISSIONS.RELATORIO_ESCALACAO_MENOR,
      PERMISSIONS.RELATORIO_FIGURANTES_BLOQUEADOS,
      PERMISSIONS.RELATORIO_SEGUROS,
      PERMISSIONS.RELATORIO_PEDIDOS_FIGURACAO,
      PERMISSIONS.RELATORIO_RESUMO_PEDIDO,
    ],
    profiles: [
      PROFILES.GESTAO_FIGURACAO,
      PROFILES.ANALISTA,
      PROFILES.ASSISTENTE_DIRECAO,
      PROFILES.SOCIO_AGENCIA,
      PROFILES.PORTARIA_SEGURANCA,
      PROFILES.SEGUROS,
      PROFILES.PRODUTOR_GLOBO,
      PROFILES.TRANSPORTE,
    ],
    subItems: [
      {
        id: 'permits',
        label: 'Alvarás',
        icon: GavelOutlined,
        path: `/reports/${typesReports.minorLicense}`,
        permissions: [PERMISSIONS.RELATORIO_ALVARA_MENOR],
      },
      {
        id: 'access_control',
        label: 'Controle de acesso',
        icon: BadgeOutlined,
        path: `/reports/${typesReports.conciergeSecurity}`,
        permissions: [PERMISSIONS.RELATORIO_PORTARIA_SEGURANCA],
      },
      {
        id: 'insurance_data',
        label: 'Dados para seguro',
        icon: VerifiedUserOutlined,
        path: `/reports/${typesReports.insurance}`,
        permissions: [PERMISSIONS.RELATORIO_SEGUROS],
      },
      {
        id: 'record_report',
        label: 'Relatório de gravação',
        icon: AssignmentLate,
        path: '/report-record',
        permissions: [],
      },
      {
        id: 'period_agency_escalation',
        label: 'Escal. Período/Agência',
        icon: CheckBoxOutlined,
        path: `/reports/${typesReports.selectedsByAgency}`,
        permissions: [PERMISSIONS.RELATORIO_GERENCIAL_AGENCIA],
      },
      {
        id: 'minor_escalation',
        label: 'Escal. de menores',
        icon: ChildCare,
        path: `/reports/${typesReports.minorsCasting}`,
        permissions: [PERMISSIONS.RELATORIO_ESCALACAO_MENOR],
      },
      {
        id: 'figurant_blocked',
        label: 'Figurantes bloqueados',
        icon: NoAccountsOutlined,
        path: `/reports/${typesReports.blockedFigurants}`,
        permissions: [PERMISSIONS.RELATORIO_FIGURANTES_BLOQUEADOS],
      },
      {
        id: 'request_items',
        label: 'Itens do Pedido',
        icon: FormatListBulletedOutlined,
        path: `/reports/${typesReports.orderItems}`,
        permissions: [PERMISSIONS.RELATORIO_ITEM_PEDIDO],
      },
      {
        id: 'requests',
        label: 'Pedidos',
        icon: ListAltOutlined,
        path: `/reports/${typesReports.ordersAgency}`,
        permissions: [PERMISSIONS.RELATORIO_PEDIDOS_FIGURACAO],
      },
      {
        id: 'cost_request',
        label: 'Pedido de Custo',
        icon: RequestQuoteOutlined,
        path: `/reports/${typesReports.ordersCosts}`,
        permissions: [PERMISSIONS.RELATORIO_GERENCIAL],
      },
      {
        id: 'order_summary',
        label: 'Resumo de pedidos',
        icon: SummarizeOutlined,
        path: `/reports/${typesReports.summaryOrder}`,
        permissions: [PERMISSIONS.RELATORIO_RESUMO_PEDIDO],
      },
      {
        id: 'valuation',
        label: 'Valoração',
        icon: SsidChartOutlined,
        path: `/reports/${typesReports.valuationOrder}`,
        permissions: [PERMISSIONS.RELATORIO_VALORACAO],
      },
    ],
  },
];

export { MenuItems };
